import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initLocale } from './i18n';
import './styles/app.css';

initLocale();

const el = document.getElementById('root');
if (!el) throw new Error('#root element missing');
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>
);
